module.exports = __webpack_public_path__ + "img/16-02_Being Open.4b0506ab.svg";